module.exports = __webpack_public_path__ + "static/mw10-7c4e37a3d2eb4ca6b655d78c66412d1e.jpg";